// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1604f5a628b4db6d6f99ccec28f5379e5c8ab737/static/css/" + chunkId + "." + {"481":"144724f8","729":"40937596","820":"a5137a1f"}[chunkId] + ".chunk.css";
};